<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <el-table class="table-striped wrap-whole-words"
                  border
                  @selection-change="handleSelectionChange"
                  :data="tasks"
                  style="width: 100%">
          <el-table-column
            type="selection"
            fixed="left"
            width="55">
          </el-table-column>
          <el-table-column
            :min-width="160"
            sortable
            :sort-method="(a, b) => callStringSort(a, b, 'name')"
            prop="name"
            label="Name">
          </el-table-column>
          <el-table-column
            label="Due Date"
            :min-width="150"
            sortable
            prop="dueDate">
            <template slot-scope="props">
              {{ props.row.dueDate | formatDate }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <button type="button" :disabled="isAddEmptyTaskFoldersDisabled" @click="addEmptyTaskFolders" class="btn btn-md btn-fill btn-info pull-right">
          Add Empty Task Folder(s)
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import {OK, CREATED} from 'http-status-codes'
import {notifySuccess, notifyError, getEntityFolderName, stringSort} from 'src/utilities/utils'
import {createFolder} from 'src/utilities/fileManagerApi'

export default {
  props: ['data'],
  computed: {
    isAddEmptyTaskFoldersDisabled() {
      return this.selectedTasks.length === 0
    },
  },
  data() {
    return {
      selectedTasks: [],
      tasks: []
    }
  },
  methods: {
    handleSelectionChange(selectedTasks) {
      this.selectedTasks = selectedTasks
    },
    callStringSort(a, b, prop) {
      return stringSort(a, b, prop)
    },
    async addEmptyTaskFolders() {
      let allSucceeded = true

      for (const task of this.selectedTasks) {
        let taskFolderName = getEntityFolderName(task)

        if (task.fieldValues.reinspectionCount) {
          taskFolderName += ` (${task.fieldValues.reinspectionCount})`
        } else if (task.fieldValues.repeatCount) {
          taskFolderName += ` (${task.fieldValues.repeatCount})`
        }

        const taskFolderPath = `${this.data.jobPath}/${taskFolderName}`

        const response = await createFolder(taskFolderPath)

        if (CREATED === response.status) {
          notifySuccess(this, `Created ${taskFolderName} successfully`)
        } else {
          allSucceeded = false
          notifyError(this, `Failed to create ${taskFolderName}`)
        }
      }

      if (allSucceeded) {
        this.selectedTasks = []
        await this.$store.dispatch('files/fetchDirectoryContents', this.data.jobPath)
        this.$store.commit('files/jobId', null)
        this.$store.commit('files/jobPath', null)
        this.$emit('close')
      }
    }
  },
  async mounted() {
    const tasksResponse = await this.$store.dispatch('tasks/fetchTasksByJobId', this.data.jobId)
    if (OK !== tasksResponse.status) {
      notifyError(this, 'Failed to retrieve PTRAC tasks for job ID ' + this.data.jobId)
      return
    }

    const fileManagerResponse = await this.$store.dispatch('files/fetchJobDirectoryContents', this.data.jobPath)

    if (OK !== fileManagerResponse.status) {
      notifyError(this, 'Failed to retrieve folder contents for ' + this.data.jobPath)
      return
    }

    if (fileManagerResponse.data.folders.length === 0) {
      this.tasks = tasksResponse.data
      return
    }

    const tasksWithoutFolders = []
    const folders = fileManagerResponse.data.folders

    for (const task of tasksResponse.data) {
      const taskFolderName = getEntityFolderName(task)

      if (!folders.includes(taskFolderName)) {
        tasksWithoutFolders.push(task)
      }
    }

    this.tasks = tasksWithoutFolders
  }
}
</script>
